













































































































import { baseUrl } from "@/baseUrl";
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    valid: false,
    showError: false,
    password: "",
    passwordRules: [
      (v: any) => !!v || "Wachtwoord is verplicht",
      (v: any) => v.length >= 8 || "Wachtwoord moet minimaal 8 lang zijn.",
    ],
    retypePassword: "",
    baseUrl: baseUrl,
  }),

  components: {},

  mounted() {
      if(!this.$route.query.email || !this.$route.query.token) {
          this.$router.push('/login')
      }
  },

  methods: {
    async onResetPassword() {
      this.showError = false;
      if (this.valid) {
        this.postData().then((data) => {
          if (data) {
            this.$router.push("/");
          }
        });
      } else {
        this.showError = true;
      }
    },
    async postData() {
      try {
        const response = await fetch(`${this.$api}/v2/user/resetPassword`, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify({
            email: this.$route.query.email,
            token: this.$route.query.token,
            password: this.password
          }),
        });
        return response.text();
      } catch (e) {
        console.error(e);
      }
    },
  },
});
